import { compareDatatableStates, DatatableState, filterDatatableStateByColumns } from "../../models/datatable-state-model";

interface StoredViewComparisonContext {
  currentActiveView?: { storedViewId?: string | null } | null;
  baseDatatableState: DatatableState;
  currentStoredViewDatatableState: DatatableState | null;
}

interface ComputeHasUnsavedChangesParams {
  localDatatableState: DatatableState;
  currentViewContext?: StoredViewComparisonContext | null;
  localStoredViewId?: string | null;
  validColumnIdSet: Set<string>;
}

export function computeHasUnsavedChanges({
  localDatatableState,
  currentViewContext,
  localStoredViewId,
  validColumnIdSet,
}: ComputeHasUnsavedChangesParams): boolean {
  if (!currentViewContext) {
    return false;
  }

  const { currentActiveView, baseDatatableState, currentStoredViewDatatableState } = currentViewContext;

  if ((localStoredViewId ?? null) !== (currentActiveView?.storedViewId ?? null)) {
    return false;
  }

  const referenceState = currentStoredViewDatatableState ?? baseDatatableState;
  const filteredReference = filterDatatableStateByColumns(referenceState, validColumnIdSet);
  const filteredLocal = filterDatatableStateByColumns(localDatatableState, validColumnIdSet);

  return !compareDatatableStates(filteredLocal, filteredReference);
}
